<template>
  <div>
<!--    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="197.542" height="194.875"-->
<!--         viewBox="0 0 197.542 194.875" v-if="name !== 'explore'">-->
<!--      <defs>-->
<!--        <filter id="Path_28253" x="0" y="0" width="197.542" height="194.875" filterUnits="userSpaceOnUse">-->
<!--          <feOffset dy="3" input="SourceAlpha"/>-->
<!--          <feGaussianBlur stdDeviation="3" result="blur"/>-->
<!--          <feFlood flood-opacity="0.161"/>-->
<!--          <feComposite operator="in" in2="blur"/>-->
<!--          <feComposite in="SourceGraphic"/>-->
<!--        </filter>-->
<!--      </defs>-->
<!--      <g id="Group_50838" data-name="Group 50838" transform="translate(-7955.494 -16517.969)">-->
<!--        <g id="Group_50836" data-name="Group 50836" transform="translate(6574.494 15075.188)">-->
<!--          <path id="Path_28252" data-name="Path 28252"-->
<!--                d="M5493.527,2161.28v92.235l83.166,41.466,84.073-41.466V2161.28a205.535,205.535,0,0,0-29.307-9.959c-5.153-1.337-9.627-2.333-13.548-3.111a118.706,118.706,0,0,0-13.294-1.992s-9-15.326-27.924-14.894-26.106,14.894-26.106,14.894a180.28,180.28,0,0,0-29.9,5.1A201.409,201.409,0,0,0,5493.527,2161.28Z"-->
<!--                transform="translate(-4097.534 -676.917)" fill="#cfd6cb" stroke="#345d48" stroke-width="4"/>-->
<!--          <g transform="matrix(1, 0, 0, 1, 1381, 1442.78)" filter="url(#Path_28253)">-->
<!--            <path id="Path_28253-2" data-name="Path 28253"-->
<!--                  d="M5493.528,2163.842v99.127l88.287,44.564,89.255-44.564v-99.127a216.534,216.534,0,0,0-31.115-10.7c-5.469-1.436-10.218-2.507-14.381-3.343a127.882,127.882,0,0,0-13.674-2.141,36.271,36.271,0,0,0-30.084-14.867c-20.089.466-29.087,14.867-29.087,14.867a185.041,185.041,0,0,0-30.372,5.485A212.123,212.123,0,0,0,5493.528,2163.842Z"-->
<!--                  transform="translate(-5483.53 -2125.78)" fill="none" stroke="#345d48" stroke-width="2"/>-->
<!--          </g>-->
<!--        </g>-->
<!--        <text id="explore_more_ameniti" data-name="explore more ameniti" transform="translate(7986.265 16580.5)"-->
<!--              fill="#585f6c" font-size="25" font-family="Didot-Bold, Didot" font-weight="700" letter-spacing="0.07em"-->
<!--              v-if="name === 'lot'">-->
<!--          <tspan x="10.612" y="24">SELECT</tspan>-->
<!--          <tspan x="38" y="56">LOT</tspan>-->
<!--        </text>-->
<!--        <text id="explore_more_ameniti" data-name="explore more ameniti" transform="translate(7986.265 16580.5)"-->
<!--              fill="#585f6c" font-size="25" font-family="Didot-Bold, Didot" font-weight="700" letter-spacing="0.07em"-->
<!--              v-if="name === 'home'">-->
<!--          <tspan x="10.612" y="24">SELECT</tspan>-->
<!--          <tspan x="20" y="56">HOME</tspan>-->
<!--        </text>-->
<!--        <text id="explore_more_ameniti" data-name="explore more ameniti" transform="translate(7986.265 16580.5)"-->
<!--              fill="#585f6c" font-size="25" font-family="Didot-Bold, Didot" font-weight="700" letter-spacing="0.07em"-->
<!--              v-if="name === 'exterior'">-->
<!--          <tspan x="10.612" y="24">SELECT</tspan>-->
<!--          <tspan x="-9" y="56">EXTERIOR</tspan>-->
<!--        </text>-->
<!--        <text class="num" id="_1" data-name="1" transform="translate(8046 16560)" fill="#345d48" font-size="30"-->
<!--              font-family="Didot-Bold, Didot" font-weight="700">-->
<!--          <tspan x="0" y="0">-->
<!--            {{ number }}-->
<!--          </tspan>-->
<!--        </text>-->
<!--      </g>-->
<!--    </svg>-->

<!--    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 245.55223 52.64014" v-if="name !== 'explore'">-->
<!--      <g id="Layer_2" data-name="Layer 2">-->
<!--        <g id="Layer_1-2" data-name="Layer 1">-->
<!--          <g id="Group_50852" data-name="Group 50852">-->
<!--            <path id="Path_28289" data-name="Path 28289"-->
<!--                  d="M15.2016,52.14014l-5.779-6.281v-4.353l-8.844-15.186,8.844-15.186V6.781L15.2016.5h215.149l5.778,6.281v4.353l8.845,15.186-8.845,15.186v4.353l-5.778,6.281Z"-->
<!--                  style="fill:none;stroke:#345d48"/>-->
<!--            <path id="Path_28290" data-name="Path 28290"-->
<!--                  d="M228.62164,4.436l3.57,3.87988V12.1958l8.226,14.12305-8.226,14.123v3.87989l-3.57,3.87988H16.92862l-3.57-3.87988V40.44189l-8.226-14.123,8.226-14.123V8.31592l3.57-3.87988Z"-->
<!--                  style="fill:#cfd6cb;stroke:#345d48;stroke-miterlimit:10;stroke-width:2px"/>-->
<!--            <circle id="Ellipse_9422" data-name="Ellipse 9422" cx="16.5406" cy="26.31902" r="1.862"-->
<!--                    style="fill:#cfd6cb;stroke:#345d48;stroke-width:0.5px"/>-->
<!--            <circle id="Ellipse_9423" data-name="Ellipse 9423" cx="229.0096" cy="26.31902" r="1.862"-->
<!--                    style="fill:#cfd6cb;stroke:#345d48;stroke-width:0.5px"/>-->
<!--            <text transform="translate(42.53092 31.69683)"-->
<!--                  style="font-size:19px;font-family:Didot-Bold, Didot;font-weight:700">-->
<!--              <tspan xml:space="preserve">{{number}}    SELECT {{ name }}</tspan>-->
<!--            </text>-->
<!--          </g>-->
<!--        </g>-->
<!--      </g>-->
<!--    </svg>-->

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276.89004 52.64014" v-if="name !== 'explore'">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path id="Path_28289" data-name="Path 28289"
                d="M17.09393,52.14014l-6.51908-6.281v-4.353l-9.9766-15.186,9.9766-15.186V6.781L17.09393.5H259.79609l6.518,6.281v4.353l9.97771,15.186-9.97771,15.186v4.353l-6.518,6.281Z"
                style="fill:none;stroke:#345d48"/>
          <path id="Path_28290" data-name="Path 28290"
                d="M257.8457,4.436l4.0272,3.87988V12.1958l9.27948,14.12305-9.27948,14.123v3.87989l-4.0272,3.87988H19.04212l-4.0272-3.87988V40.44189l-9.27948-14.123,9.27948-14.123V8.31592L19.04212,4.436Z"
                style="fill:#cfd6cb;stroke:#345d48;stroke-miterlimit:10;stroke-width:2px"/>
          <circle id="Ellipse_9423" data-name="Ellipse 9423" cx="260.6785" cy="26.31902" r="3.67331"
                  style="fill:#cfd6cb;stroke:#345d48;stroke-width:0.5px"/>
          <circle id="Ellipse_9423-2" data-name="Ellipse 9423" cx="16.6785" cy="26.31902" r="3.67331"
                  style="fill:#cfd6cb;stroke:#345d48;stroke-width:0.5px"/>
          <text transform="translate(60 31.69683)"
                style="font-size:19px;font-family:Didot-Bold, Didot;font-weight:700; text-align: center" v-if="name === 'lot'">
            <tspan>{{number}}. </tspan>SELECT LOT
          </text>

          <text transform="translate(21.5 31.69683)"
                style="font-size:19px;font-family:Didot-Bold, Didot;font-weight:700; text-align: center" v-if="name === 'home'">
            <tspan>{{number}}. </tspan>SELECT FLOORPLAN
          </text>

          <text transform="translate(30 31.69683)"
                style="font-size:19px;font-family:Didot-Bold, Didot;font-weight:700; text-align: center" v-if="name === 'exterior'">
            <tspan>{{number}}. </tspan>SELECT EXTERIOR
          </text>


<!--          <text transform="translate(24.68641 31.69677)" class="num"-->
<!--                style="font-size:19px;font-family:Didot-Bold, Didot;font-weight:700">{{number}}-->
<!--          </text>-->
        </g>
      </g>
    </svg>

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 348.9922 52.64014" v-if="name === 'explore'">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path id="Path_28289" data-name="Path 28289"
                d="M21.453,52.14014l-8.2216-6.281v-4.353L.64932,26.32007,13.23141,11.134V6.781L21.453.5H327.53916l8.22021,6.281v4.353l12.58348,15.186-12.58348,15.186v4.353l-8.22021,6.281Z"
                style="fill:none;stroke:#345d48"/>
          <path id="Path_28290" data-name="Path 28290"
                d="M325.0794,4.436l5.07894,3.87988V12.1958l11.70291,14.12305-11.70291,14.123v3.87989l-5.07894,3.87988H23.91l-5.07894-3.87988V40.44189L7.12814,26.31885l11.70291-14.123V8.31592L23.91,4.436Z"
                style="fill:#cfd6cb;stroke:#345d48;stroke-miterlimit:10;stroke-width:2px"/>
          <circle id="Ellipse_9423" data-name="Ellipse 9423" cx="329.72958" cy="26.31902" r="3.67331"
                  style="fill:#cfd6cb;stroke:#345d48;stroke-width:0.5px"/>
          <circle id="Ellipse_9423-2" data-name="Ellipse 9423" cx="19.72958" cy="26.31902" r="3.67331"
                  style="fill:#cfd6cb;stroke:#345d48;stroke-width:0.5px"/>
          <text transform="translate(27 32.69683)"
                style="font-size:19px;font-family:Didot-Bold, Didot;font-weight:700">4. EXPLORE YOUR NEW HOME
          </text>
        </g>
      </g>
    </svg>




    <!--    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 179.54199 176.86963" v-if="name === 'explore'">-->
<!--      <g id="Layer_2" data-name="Layer 2">-->
<!--        <g id="Layer_1-2" data-name="Layer 1">-->
<!--          <g id="Group_50842" data-name="Group 50842">-->
<!--            <g id="Group_50839" data-name="Group 50839">-->
<!--              <path id="Path_28252" data-name="Path 28252"-->
<!--                    d="M5.99463,35.58077v92.2351l83.166,41.46607,84.07276-41.46607V35.58077a205.55807,205.55807,0,0,0-29.30713-9.959c-5.15283-1.33691-9.62695-2.333-13.54785-3.11108a118.71235,118.71235,0,0,0-13.294-1.99195s-9-15.32592-27.92383-14.894-26.10595,14.894-26.10595,14.894a180.2953,180.2953,0,0,0-29.8999,5.1001A201.41968,201.41968,0,0,0,5.99463,35.58077Z"-->
<!--                    style="fill:#cfd6cb;stroke:#345d48;stroke-width:4px"/>-->
<!--              <path id="Path_28253-2" data-name="Path 28253-2"-->
<!--                    d="M1,32.05977v99.127l88.28711,44.564,89.25488-44.564v-99.127a216.54047,216.54047,0,0,0-31.11523-10.7c-5.46924-1.436-10.21778-2.50708-14.38086-3.343a127.89043,127.89043,0,0,0-13.67383-2.14111,36.27056,36.27056,0,0,0-30.084-14.86695c-20.08887.46607-29.08692,14.867-29.08692,14.867A185.0528,185.0528,0,0,0,29.8291,21.3608,212.14391,212.14391,0,0,0,1,32.05977Z"-->
<!--                    style="fill:none;stroke:#345d48;stroke-width:2px"/>-->
<!--            </g>-->
<!--            <g id="explore_more_ameniti" data-name="explore more ameniti" style="isolation:isolate">-->
<!--              <text transform="translate(28.74543 70.52923)"-->
<!--                    style="isolation:isolate;font-size:22px;fill:#585f6c;font-family:Didot-Bold, Didot;font-weight:700;letter-spacing:0.07000177556818182em">-->
<!--                EXPLORE-->
<!--              </text>-->
<!--              <text transform="translate(20.41843 98.52926)"-->
<!--                    style="isolation:isolate;font-size:22px;fill:#585f6c;font-family:Didot-Bold, Didot;font-weight:700;letter-spacing:0.07000177556818182em">-->
<!--                YOUR NEW-->
<!--              </text>-->
<!--              <text transform="translate(51.0094 126.52926)"-->
<!--                    style="isolation:isolate;font-size:22px;fill:#585f6c;font-family:Didot-Bold, Didot;font-weight:700;letter-spacing:0.07000177556818182em">-->
<!--                HOME-->
<!--              </text>-->
<!--            </g>-->
<!--            <g id="_4" data-name=" 4" style="isolation:isolate" class="num">-->
<!--              <text transform="translate(81.50782 36.02923)"-->
<!--                    style="isolation:isolate;font-size:30px;fill:#345d48;font-family:Didot-Bold, Didot;font-weight:700">-->
<!--                4-->
<!--              </text>-->
<!--            </g>-->
<!--          </g>-->
<!--        </g>-->
<!--      </g>-->
<!--    </svg>-->


  </div>
</template>

<script>
export default {

  name: 'app-selector',
  mixins: [],
  components: {},
  data() {
    return {}
  },
  props: {
    name: String,
    number: String,

  },
  watch: {},
  created() {
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/journey/nav/Selector.vue